import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RuntimeConfig } from '@/types/configuration.type';
import configurationApi from '@/services/configuration.api';

export type ConfigurationState = {
  runtimeConfig: RuntimeConfig | null;
};

const initialState: ConfigurationState = {
  runtimeConfig: null,
};

const slice = createSlice({
  name: 'configuration',
  initialState,
  reducers: {
    setRuntimeConfig: (state, action: PayloadAction<RuntimeConfig>) => {
      state.runtimeConfig = action.payload;
    },
  },
  extraReducers: builder => {
    // Live path (联调): a successful fetch auto-populates the same store slice.
    builder.addMatcher(
      configurationApi.endpoints.getConfiguration.matchFulfilled,
      (state, { payload }) => {
        state.runtimeConfig = payload;
      }
    );
  },
});

export const { setRuntimeConfig } = slice.actions;

export const selectRuntimeConfig = (state: {
  configuration: ConfigurationState;
}) => state.configuration.runtimeConfig;

export default slice.reducer;
